import { Card } from "../../components/common/Card";
import { GapNotice } from "../../components/common/GapNotice";

/** appInsightsApi is entirely GAP-flagged -- see that file's header comment.
 * This page lays out what each section should show once a backend proxy to
 * the App Insights Query API exists. */
export function AppInsightsPage() {
  return (
    <div>
      <h1>Application Insights</h1>
      <p style={{ color: "var(--color-text-muted)" }}>
        None of the sections below are wired up -- see services/appInsightsApi.js. Querying App Insights requires an
        API key that must stay server-side, so all of these need a backend proxy endpoint first.
      </p>

      <Card title="Real-Time Error Aggregation & Grouping" className="section-spacing">
        <GapNotice>Would group app.exceptions by type/message via App Insights' Query API (KQL).</GapNotice>
      </Card>
      <Card title="Performance Bottlenecks" className="section-spacing">
        <GapNotice>Would visualize app.performanceCounters/app.dependencies latency breakdowns.</GapNotice>
      </Card>
      <Card title="Error Trends (Weekly/Monthly Comparison)" className="section-spacing">
        <GapNotice>Would compare app.exceptions counts week-over-week/month-over-month.</GapNotice>
      </Card>
      <Card title="Slowest Endpoints (Top 10)" className="section-spacing">
        <GapNotice>
          Note: api/functions/admin.py's existing slow_queries endpoint already covers this at the SQL level via
          audit.PerformanceMetrics (see Performance Monitoring) -- this section would be the App-Insights-level view
          (including client-side/network time App Insights captures that SQL-level metrics can't), a complement, not
          a duplicate.
        </GapNotice>
      </Card>
      <Card title="User Session Replays (PII-Redacted)">
        <GapNotice>Same session-recording gap noted on the Security Monitoring page -- needs a client-side recording library and a real privacy review before implementation, not just a missing endpoint.</GapNotice>
      </Card>
    </div>
  );
}
